<template>
  <gw-listing class="a7-estado-listing" :refresh="refresh" :title="$t('Estado')"
  :default-filter-params="defaultFilterParams" modal-size="small"
  :entity-dto-rest-resource="entityDTORestResource"
  :presentation="presentation"
  >
    <gw-column field="nome"/>
    <gw-column field="sigla"/>
    <gw-column field="codigoIBGE" />

    <template slot="filterBand">
      <gw-text-filter-item :display-text="$t('Estado.ui.filtroNome')"
        property-name="nomeEstado"/>
    </template>

    <template slot="editor">
      <gw-grouping-pane :title="$t('Global.ui.detalhes')">
        <gw-grid-container>
          <div class="gw-row">
            <gw-editor-field property="nome" class="gw-col-6"/>
            <gw-editor-field property="sigla" class="gw-col-6"/>
          </div>
          <div class="gw-row">
            <gw-editor-field property="codigoIBGE" class="gw-col-6" showDescription/>
          </div>
        </gw-grid-container>
      </gw-grouping-pane>
    </template>

  </gw-listing>
</template>

<script>
/**
 * UI0008
*/
import {
  GwListing,
  GwTextFilterItem,
  GwColumn,
  GwEditorField,
  GwGroupingPane,
  GwGridContainer,
  FilterUtilities
} from "guaxinim-web";
import EstadoRestResource from './EstadoRestResource'

export default {
  name: "a7-estado-listing",
  components: {
    GwListing,
    GwTextFilterItem,
    GwColumn,
    GwEditorField,
    GwGroupingPane,
    GwGridContainer
  },
  props: {
    defaultFilterParams: {
      type: Object
    },
  },
  data() {
    return {
      entityDTORestResource: EstadoRestResource,
      presentation: null
    }
  },
  methods: {
    refresh(filterParams) {
      return this.entityDTORestResource.findDTOs(null,
        FilterUtilities.createFilterParamsString(filterParams));
    },
    search(pattern) {
      return this.entityDTORestResource.findEstadoFinderDTO(null, pattern, 10);
    },
    findEntityByID(id) {
      return this.entityDTORestResource.findEstadoFinderDTOByID(id);
    }
  },
  created() {
    this.entityDTORestResource.getDtoPresentation()
      .then(presentation => this.presentation = presentation)
      .catch((err) => this.$gw.defaultExceptionHandler.handleUnknowException(err, this));
  }
};
</script>

<style lang="scss" scoped>

</style>